import { render, staticRenderFns } from "./Tabelas.vue?vue&type=template&id=a0cec880"
import script from "./Tabelas.vue?vue&type=script&lang=js"
export * from "./Tabelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports